module.exports = __webpack_public_path__ + "img/beneficiaire.0f1e5e3d.png";